export const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};






// WEBPACK FOOTER //
// ./src/misc/inIframe.js